var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"w-full pr-3 pb-3"},[(false)?_vm._t("title"):_vm._e(),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }